module.exports = __webpack_public_path__ + "static/IvarText-Regular-ded8cafc0078ecdba00e103c4cdbee00.woff";